import "./src/styles/global.css"
import {wpe} from "./wrapPageElement";

export const wrapPageElement = wpe;
